import { invariant, InvariantError } from "ts-invariant";
import DEV from "./DEV";
export { DEV };
export function checkDEV() {
    __DEV__ ? invariant("boolean" === typeof DEV, DEV) : invariant("boolean" === typeof DEV, 39);
}
import { removeTemporaryGlobals } from "./fix-graphql";
removeTemporaryGlobals();
export { maybe } from "./maybe";
export { default as global } from "./global";
export { invariant, InvariantError };
checkDEV();
//# sourceMappingURL=index.js.map